import { render } from "./FiltreCurrentCart.vue?vue&type=template&id=3d3bf444"
import script from "./FiltreCurrentCart.vue?vue&type=script&lang=ts"
export * from "./FiltreCurrentCart.vue?vue&type=script&lang=ts"
script.render = render

export default script